import { BaseComponent, BElement } from "../../utils/base-component"
import units from "../../utils/units"
import "./index.scss"

export class SnowAmount extends BaseComponent {
  static cssClass = "snow-amount"

  value?: number
  text!: BElement
  units?: BElement

  init() {
    this.text = this.element("value")!
    this.units = this.element("units") ?? undefined

    const value = parseFloat(this.root.dataset.value!)
    this.value = Number.isNaN(value) ? undefined : value

    this.render()
    units.onChange(() => this.render())
  }

  render() {
    if (!this.text) return

    this.text.setText(this.value ? units.formatSnow(this.value) : "—")
    if (this.units) this.units.element.innerText = units.formatSnowUnits()
  }
}
